<div class="timeline-container">
  <div class="timeline-row">
    <!-- Applicant Card -->
    <div class="timeline-item" (click)="toggleCardExpansion('Applicant')">
      <div class="timeline-card">
        <div class="step-label">1</div>
        <div class="shadow" [class.expanded]="expandedState['Applicant']">
          <h3>Applicant</h3>
          <div *ngFor="let item of groupedTimelineData['Applicant']">
            <p class="label">{{ item.status }}</p>
            <p class="time">{{ item.timestamp | date : "medium" }}</p>
          </div>
          <!-- Toggle Button -->
          <button class="expand-btn" (click)="toggleCardExpansion('Applicant')">
            <span class="arrow-down"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- HSO Card -->
    <div class="timeline-column">
      <div class="timeline-item" (click)="toggleCardExpansion('HSO')">
        <div class="timeline-card">
          <div class="step-label">2</div>
          <div class="shadow" [class.expanded]="expandedState['HSO']">
            <h3>HSO</h3>
            <div *ngFor="let item of groupedTimelineData['HSO']">
              <p class="label">
                {{ item.name }}
              </p>
              <p class="label" [ngStyle]="{ color: item.color }">
                {{ item.status }}
              </p>
              <p class="time">{{ item.timestamp | date : "medium" }}</p>
            </div>
            <!-- Toggle Button -->
            <button class="expand-btn" (click)="toggleCardExpansion('HSO')">
              <span class="arrow-down"></span>
            </button>
          </div>
        </div>
      </div>

      <!-- BCPO Card -->
      <div class="timeline-item" (click)="toggleCardExpansion('BCPO')">
        <div class="timeline-card">
          <div class="shadow" [class.expanded]="expandedState['BCPO']">
            <h3>BCPO</h3>
            <div *ngFor="let item of groupedTimelineData['BCPO']">
              <p class="label">{{ item.status }}</p>
              <p class="time">{{ item.timestamp | date : "medium" }}</p>
            </div>
            <!-- Toggle Button -->
            <button class="expand-btn" (click)="toggleCardExpansion('BCPO')">
              <span class="arrow-down"></span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- PESO Card -->
    <div class="timeline-item" (click)="toggleCardExpansion('PESO-A')">
      <div class="timeline-card">
        <div class="step-label">3</div>
        <div class="shadow" [class.expanded]="expandedState['PESO-A']">
          <h3>PESO</h3>
          <div *ngFor="let item of groupedTimelineData['PESO-A']">
            <p class="label">{{ item.status }}</p>
            <p class="time">{{ item.timestamp | date : "medium" }}</p>
          </div>
          <!-- Toggle Button -->
          <button class="expand-btn" (click)="toggleCardExpansion('PESO-A')">
            <span class="arrow-down"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- CMO Card -->
    <div class="timeline-item" (click)="toggleCardExpansion('CMO')">
      <div class="timeline-card">
        <div class="step-label">4</div>
        <div class="shadow" [class.expanded]="expandedState['CMO']">
          <h3>CMO</h3>
          <div *ngFor="let item of groupedTimelineData['CMO']">
            <p class="label">{{ item.status }}</p>
            <p class="time">{{ item.timestamp | date : "medium" }}</p>
          </div>
          <!-- Toggle Button -->
          <button class="expand-btn" (click)="toggleCardExpansion('CMO')">
            <span class="arrow-down"></span>
          </button>
        </div>
      </div>
    </div>

    <div class="timeline-item" (click)="toggleCardExpansion('PESO-B')">
      <div class="timeline-card">
        <div class="step-label">5</div>
        <div class="shadow" [class.expanded]="expandedState['PESO-B']">
          <h3>PESO</h3>
          <div *ngFor="let item of groupedTimelineData['PESO-B']">
            <p class="label">{{ item.status }}</p>
            <p class="time">{{ item.timestamp | date : "medium" }}</p>
          </div>
          <!-- Toggle Button -->
          <button class="expand-btn" (click)="toggleCardExpansion('PESO-B')">
            <span class="arrow-down"></span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Connecting Line -->
  <div class="timeline-line"></div>

  <div class="row" *ngIf="userType == 'evaluator'">
    <div class="d-flex justify-content-end">
      <div
        class="col-12 col-lg-3"
        style="padding-left: 25px; padding-right: 25px"
      >
        <div class="inner-container">
          <mat-label>Legend</mat-label>
          <div class="row">
            <div class="col-12 col-lg-12">
              <span class="me-2">--</span>
              <span>Evaluation Skipped</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
